/**
 * saas接口相关
 * @author ytl
 */

import axios from 'axios';
import {INTERACE_SAAS_BASE_URL} from 'src/config/params-local';
import {setSessionStorageItem, getSessionStorageItem, getLocalStorageItem, setLocalStorageItem} from 'components/api/utils';
import {getUserIdentity, logging} from 'components/api/interface-hhy';

// businessType 堂食自助(（扫码点餐）):TS，秒吃(预约堂食)：MC，自提（预约自提）：ZT，外送（预约外送）：WS，
export const BUSINESS_TYPE_TS = 'TS';
export const BUSINESS_TYPE_MC = 'MC';
export const BUSINESS_TYPE_ZT = 'ZT';
export const BUSINESS_TYPE_WS = 'WS';
export const BUSINESS_TYPE_JC = 'JC';

// 是否需要打包
export const NEED_PACKAGE_YES = 'YES';
export const NEED_PACKAGE_NO = 'NO';

// 字典 dictGroup
export const DICT_GROUP_BUSINESS_TYPE = 'BUSINESS_TYPE';

// 业务开通状态 OPEN/NO
export const BUSINESS_TYPE_STATUS_OPEN = 'OPEN';
export const BUSINESS_TYPE_STATUS_NO = 'NO';

// 扫码点餐之后类型 先支付/后支付/只点餐不结账/点餐支付+扫码结账
export const TS_PAY_TYPE_BEFORE = 'BEFORE';
export const TS_PAY_TYPE_AFTER = 'AFTER';
export const TS_PAY_TYPE_NOPAY = 'NOPAY';
export const TS_PAY_TYPE_BOTH = 'BOTH';

/**
 * 创建axios实例
 * @return {axios}
 */
export function createHttp() {
  let $httpSaas = axios.create({
    baseURL: INTERACE_SAAS_BASE_URL,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Cache-Control': 'no-cache'
    },
    timeout: 30000
  });

// 添加一个响应拦截器
  $httpSaas.interceptors.response.use(res => {
    if (res.data.code && res.data.code === -1) {
      logging({ request: res.config, responseData: res.data });
      let errMsg = {message: res.data.msg ? res.data.msg : ''};
      return Promise.reject(errMsg);
    }
    return 'body' in res.data ? res.data.body : res.data;
  }, err => {
    let responseData = err.response ? err.response.data : null;
    logging({
      request: err.config,
      responseData,
      err: responseData ? null : err
    });
    let errorInfo = err.response ? err.response.data : err;
    return Promise.reject(errorInfo);
  });
  return $httpSaas;
}

/**
 * 创建axios实例--测试
 * @return {axios}
 */
export function createHttpTest() {
  let $httpSaas = axios.create();
// 添加一个响应拦截器
  $httpSaas.interceptors.response.use(res => {
    if (res.data.code && res.data.code === -1) {
      let errMsg = {response: {data: {message: res.data.msg ? res.data.msg : ''}}};
      return Promise.reject(errMsg);
    }
    return res.data.body ? res.data.body : res.data;
  }, err => {
    return Promise.reject(err);
  });
  return $httpSaas;
}

/**
 * 查询字段数据接口
 * @param dictGroup 字典组编码
 * @param dictCode 字典详情编码 ''表示查询所有
 * @return {Promise}
 */
export function getDictItems (dictGroup, dictCode = '') {
  let dictItems = getLocalStorageItem('dictItems') ? getLocalStorageItem('dictItems') : {};
  if (!dictItems || !dictItems[dictGroup] || (dictCode !== '' && !dictItems[dictGroup][dictCode])) {
    let url = '/dict-group/' + dictGroup + '/dict-item';
    let $httpSaas = createHttp();
    $httpSaas.interceptors.response.use(res => {
      dictItems[dictGroup] = {};
      res.forEach(row => {
        let itemDictCode = row.reDictItem.dictCode;
        dictItems[dictGroup][itemDictCode] = row.reDictItem;
      });
      setLocalStorageItem('dictItems', dictItems, 86400);
      return dictCode ? row.reDictItem : dictItems[dictGroup];
    });
    return $httpSaas.get(url);
  }

  if (dictCode === '') {
    return Promise.resolve(dictItems[dictGroup]);
  }

  return Promise.resolve(dictItems[dictGroup][dictCode]);
}
/**
 * GET /v1/branch/{branchId}/mc-setting
 * GET /v1/branch/{branchId}/ts-setting
 * GET /v1/branch/{branchId}/ws-setting
 * GET /v1/branch/{branchId}/zt-setting
 * 获取业务设置信息
 * @return {Promise}
 */
export function getBusinessSetting() {
  let userIdentity = getUserIdentity(),
      businessType = userIdentity.businessType.toLocaleLowerCase(),
      url = '/branch/' + userIdentity.branchId + '/' + businessType + '-setting' + '?r=' + (new Date().getTime()),
      $httpSaas = createHttp();
  return $httpSaas.get(url);
}

/**
 * /food-catalog/branch-id/{branchId}/customer-level/{customerLevel}/business-type/{businessType}/business-hours/{businessHours}
 * 获取菜例列表
 * @param businessHours 扫码点餐无需传递；
 * @param businessType
 * @return {Promise}
 */
export function getGoodsList(businessType, businessHours = 0) {
  let userIdentity = getUserIdentity();
  let {menuType} = userIdentity;
  let url;
  if (menuType) {
    url = '/food-catalog/branch-id/' + userIdentity.branchId +
      '/customer-level/' + userIdentity.levelType +
      '/business-type/' + businessType +
      '/business-hours/' + businessHours +
      '/menu?menuType=' + menuType;
  } else {
    url = '/food-catalog/branch-id/' + userIdentity.branchId +
      '/customer-level/' + userIdentity.levelType +
      '/business-type/' + businessType +
      '/business-hours/' + businessHours +
      '/new';
  }
  let $httpSaas = createHttp();
  $httpSaas.interceptors.response.use(res => {
    let userIdentity = getSessionStorageItem('userIdentity');
    let {isJC} = userIdentity;
    if (res.length > 0 && isJC !== 'NO') {
      let results;
      results = res.filter(item => item.className !== '推荐菜')
      return results;
    }
    return res;
  }, err => {
    return Promise.reject(err);
  });
  return $httpSaas.get(url);
}

/**
 * GET /setting/branch/{branchId}/set-template/{settingTypes}/page/{page}/page-size/{pageSize}
 * 获取忌口列表
 * @return {Promise}
 */
export function getJikouList () {
  let branchId = getUserIdentity('branchId');
  let url = '/setting/branch/' + branchId +
    '/set-template/JIKOU/page/1/page-size/100';
  let $httpSaas = createHttp();
  return $httpSaas.get(url);
}

/**
 * 订餐时间列表
 * GET /v1/branch/{id}/business-type/{type}/time-list
 * @param {Number} branchId
 * @return {Promise}
 */
export function getBranchTimeList (branchId) {
  let userIdentity = getUserIdentity();
  let url = '/branch/' + branchId + '/business-type/' + userIdentity.businessType + '/time-list';
  let $http = createHttp();
  return $http.get(url);
}

/**
 * 查询门店设置信息
 * GET /v1/branch/{branchId}/business-info
 * @param {Number} branchId
 * @return {Promise}
 */
export function getBranchBusinessInfo (branchId = 0) {
  !branchId && (branchId = getUserIdentity().branchId);
  let url = '/branch/' + branchId + '/business-info';
  let $http = createHttp();
  return $http.get(url);
}
/**
* 忌口消息
* GET /v1/setting/branch/{branchId}/setting-option
* @param {Number} branchId
* @return {Promise}
  */
export function getSettingOption (branchId) {
  let userIdentity = getUserIdentity();
  let url = '/setting/branch/' + userIdentity.branchId + '/setting-option';
  let $http = createHttp();
  return $http.get(url);
}
/**
 * 查询推荐菜列表
 * GET /{branchid}/recommended/food/list
 * @return {Promise}
 */
export function getRecommendFoods () {
  let {branchId, levelType} = getUserIdentity(),
    url = `/${branchId}/${levelType}/recommended/food/list`,
    $http = createHttp();
  return $http.get(url);
}

/**
 * 查询桌台基本信息
 * GET /v1/branch/{branchid}/{tableno}/{tableid}/table/info
 */
export function getTableInfo () {
  let {branchId, tableId = 0, tableNo = 0} = getUserIdentity();
  let url = `/branch/${branchId}/${tableNo || 0}/${tableId}/table/info`,
    $http = createHttp();
  return $http.get(url);
}

// POST /v1/branch/food/promotion/price
/**
 * 门店菜获取好客云活动价格
 * 该接口只返回有活动价的菜
 * @param {Array} foods
 */
export function getFoodsActivityPrice (foodList) {
  let {branchId, levelType: userLevel} = getUserIdentity();
  let url = '/branch/food/promotion/price',
    params = {
      branchId,
      channel: '',
      foodList,
      userLevel,
      bizType: BUSINESS_TYPE_TS
    },
    $http = createHttp();
  return $http.post(url, params);
}

/**
 * 查询菜品详情
 * GET /v1/branch/{branchId}/food/{id}
 * @param foodId
 */
export function getFoodDetail (foodId) {
  let {branchId} = getUserIdentity(),
    url = `/branch/${branchId}/food/${foodId}`;
  return createHttp().get(url);
  // return createHttpTest().get('/static/test/foodOptional.json');
}
/**
 * 批量查询菜品会员价
 * /v1/branch/food/vip/promotion/price
 * @param foodList
 * @return {Promise}
 */
export function getFoodsVipPrice (foodList) {
  let {branchId, businessType} = getUserIdentity(),
    url = '/branch/food/vip/promotion/price';
  return createHttp().post(url, {
    branchId,
    foodList,
    bizType: businessType
  });
}



// WEBPACK FOOTER //
// ./src/components/api/interface-saas.js